module.exports = __webpack_public_path__ + "static/img/U-head 60cm solid.1f5898a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/U-head 60cm solid.jpg
// module id = 111
// module chunks = 1